export default ({ app, route, store, $gtm, $config }) => {
    // Only run on client side
    if (process.client) {
        // Check if URL has utm_source parameter
        const utmSource = route.query.utm_source

        if (utmSource) {
            // Set cookie with 7-day lifetime (can override existing cookie)
            setCookie('utm_source', utmSource, 7, $config)

            // Send to Google Tag Manager if available
            if ($gtm) {
                $gtm.push({
                    event: 'utm_source_detected',
                    utm_source: utmSource,
                    timestamp: new Date().toISOString()
                })
            }
        }
    }
}

/**
 * Set a cookie with specified name, value and days to expire
 * @param {string} name - Cookie name
 * @param {string} value - Cookie value
 * @param {number} days - Days until expiration
 * @param {object} config - Nuxt config object
 */
function setCookie(name, value, days, config) {
    const expires = new Date()
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000))

    // Get domain from config, fallback to current domain behavior
    const domain = config.cookieDomain
    const isSecure = window.location.protocol === 'https:'

    // Build cookie string to match backend deletion exactly
    let cookieString = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`

    if (domain) {
        cookieString += `;domain=${domain}`
    }

    cookieString += `;SameSite=Lax`

    if (isSecure) {
        cookieString += `;Secure`
    }

    document.cookie = cookieString
}

/**
 * Get cookie value by name
 * @param {string} name - Cookie name
 * @returns {string|null} Cookie value or null if not found
 */
function getCookie(name) {
    const nameEQ = name + "="
    const ca = document.cookie.split(';')

    for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length))
    }
    return null
}

/**
 * Delete a cookie by name
 * @param {string} name - Cookie name
 * @param {object} config - Nuxt config object (optional)
 */
function deleteCookie(name, config = {}) {
    // Get domain from config, fallback to undefined for current domain
    const domain = config?.cookieDomain
    
    // Build cookie deletion string to match creation exactly
    let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    
    if (domain) {
        cookieString += `;domain=${domain}`
    }
    
    cookieString += `;SameSite=Lax`
    
    // Add Secure flag if on HTTPS
    if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
        cookieString += `;Secure`
    }
    
    if (typeof document !== 'undefined') {
        document.cookie = cookieString
    }
}

// Export utility functions for use in other parts of the application
export { setCookie, getCookie, deleteCookie }
